/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateNotificationTemplateItem } from './create-notification-template-item';


export interface CreateNotificationRequest { 
    identifier: string;
    description: string;
    groupId: number;
    templates?: Array<CreateNotificationTemplateItem> | null;
}

